import React, { createContext, useContext, useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import _ from "lodash";

import BeefreeAddonIndex from "./BeefreeAddonIndex";

const BeefreeAddonIndexContext = createContext();

export function useBeefreeAddonIndexContext() {
  return useContext(BeefreeAddonIndexContext);
}

const BeefreeAddonIndexProvider = (props) => {
  const {
    beeUid,
    placeholderImageUrl,
    lastTouchedVenueOwnership,
    venueOwnerships,
  } = props;

  const [venueOwnership, setVenueOwnership] = useState(lastTouchedVenueOwnership);
  const [formState, setFormState] = useState({
    eventType: "upcoming",
    align: "left",
  });
  const [selectedEvent, setSelectedEvent] = useState(null);

  const insertContent = () => {
    let eventPrefix;
    if (formState.eventType === "specific") {
      eventPrefix = selectedEvent.value;
    } else if (formState.eventType === "justforyou") {
      eventPrefix = `recommended-1`;
    } else {
      eventPrefix = `${formState.eventType}-${venueOwnership.id}-1`;
    }

    window.parent.postMessage({
      action: "onSave",
      data: {
        type: "mixed",
        value: [
          {
            type: "image",
            value: {
              alt: "Event Image",
              href: `{{${eventPrefix}.url}}`,
              src: placeholderImageUrl,
              dynamicSrc: `{{${eventPrefix}.image}}`,
              target: "_blank",
              width: "560px",
            },
          },
          {
            type: "title",
            value: {
              text: `{{${eventPrefix}.presenter}}`,
              bold: false,
              size: 14,
              align: formState.align,
            },
          },
          {
            type: "title",
            value: {
              text: `{{${eventPrefix}.name}}`,
              size: 16,
              align: formState.align,
            },
          },
          {
            type: "title",
            value: {
              text: `{{${eventPrefix}.start_date}}`,
              size: 14,
              align: formState.align,
            },
          },
          {
            type: "title",
            value: {
              text: `Doors: {{${eventPrefix}.door_time}}`,
              align: formState.align,
              size: 14,
              bold: false,
            },
          },
          {
            type: "title",
            value: {
              text: `Show: {{${eventPrefix}.start_time}}`,
              align: formState.align,
              size: 14,
              bold: false,
            },
          },
          {
            type: "title",
            value: {
              text: `{{${eventPrefix}.venue.name}}`,
              align: formState.align,
              size: 14,
              bold: false,
            },
          },
        ],
      },
    }, "*");
  };

  const searchEvents = _.debounce((inputValue, callback) => {
    new Promise(_resolve => {
      if (!inputValue) {
        callback([]);
        return;
      }

      axios.get('/beefree_addons/search_events', {
        params: {
          bee_uid: beeUid,
          search: inputValue
        }
      })
        .then(function (response) {
          callback(response.data);
        })
        .catch(function (error) {
          console.error("Error searching events:", error);
          callback([]);
        });
    });
  }, 300);

  const closeModal = () => {
    window.parent.postMessage({
      action: "onCancel",
    }, "*");
  };

  useEffect(() => {
    window.parent.postMessage({
      action: "loaded",
      data: {
        isRounded: true,
        hasTitleBar: false,
        showTitle: false,
        width: "435px",
        height: "550px",
      },
    }, "*");
  }, []);

  const value = {
    beeUid,
    placeholderImageUrl,
    venueOwnerships,
    venueOwnership,
    setVenueOwnership,
    formState,
    setFormState,
    selectedEvent,
    setSelectedEvent,
    searchEvents,
    insertContent,
    closeModal,
  };

  return (
    <BeefreeAddonIndexContext.Provider value={value}>
      {props.children}
    </BeefreeAddonIndexContext.Provider>
  );
};

const BeefreeAddonIndexContainer = (props) => (
  <BeefreeAddonIndexProvider {...props}>
    <ToastContainer icon={false} />
    <BeefreeAddonIndex />
  </BeefreeAddonIndexProvider>
);

export default BeefreeAddonIndexContainer;
